<template>
  <div class="relative z-10 space-y-4">
    <div>
      <p class="font-bold text-md">{{ $t('components.Place.review.title') }}</p>
      <p class="mt-1 leading-snug">{{ $t('components.Place.review.content') }}</p>
    </div>

    <div class="overflow-hidden bg-white dark:bg-dark-800 p-3 rounded-2xl">
      <p class="font-bold bg-text-flamingo-100 dark:text-dark-50 p-2 rounded mx-3" v-if="title">{{ title }}</p>

      <PlaceSafeRatingFormSteps class="py-1.5" :place="place" :title="title" @end="emit('end')" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Place } from '@/classes'

const props = withDefaults(defineProps<{
  place: Place
  title?: string
}>(), {
  title: ''
})

const emit = defineEmits<{
  (e: 'end'): void
}>()

const { place } = toRefs(props)

</script>